var _style, _defs, _clipPath, _g, _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDefaultProfile(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: 0,
    y: 0,
    viewBox: "0 0 500 500",
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", null, ".st15{fill:#ffbc8a}.st16{fill:#eaa77a}.st39{fill:#a4b6bc}.st40{fill:#bfccd1}.st41{fill:#88afbc}")), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("circle", {
    id: "SVGID_49_",
    cx: 250,
    cy: 250,
    r: 242.1
  }))), _clipPath || (_clipPath = /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_2_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_49_",
    overflow: "visible"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "man_35_",
    clipPath: "url(#SVGID_2_)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "man_36_"
  }, /*#__PURE__*/React.createElement("path", {
    className: "st39",
    d: "M307 399.8H193l-22.6-23.5L193 361h114l30.1 14.3z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st15",
    d: "M313.6 369.7l-18.9-8.5v-40.1h-87.6v40.1l-20.6 8.7 15.4 108.6h9.1v17.2h79.7v-17.2h9.1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st16",
    d: "M207 333.6c13.6 10.4 28.4 17.8 39.8 21 6.9 2 26.2 3.7 47.8-4.9v-28.6H207v12.5z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M419.8 426.8c-14.6-31.8-36-33.1-94.8-53.3-2.1-.7-28.5 19.8-75 21.1-46.5-1.3-72.9-21.8-75-21.1-58.8 20.2-80.1 21.4-94.8 53.3-15.7 34.9-8.3 70.9-5.9 80.4h351.4c2.4-9.5 9.8-45.6-5.9-80.4z",
    fill: "#f2f2f2"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st40",
    d: "M187.1 507.1V376.4s-93.2-5.9-118.6 70.7v60.1h118.6z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st41",
    d: "M193 361s-6.5 4-5.9 12.2v46.7l-34.1 9.6v-49.4s-3.5-12.5 40-19.1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st40",
    d: "M431.5 507.1V447c-25.5-76.6-118.6-70.7-118.6-70.7V507h118.6z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st39",
    d: "M347 429.5l-34.1-4.1v-5.5z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st41",
    d: "M307 361s6.5 4 5.9 12.2v46.7l34.1 9.6v-49.4s3.5-12.5-40-19.1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st39",
    d: "M153 429.5l34.1-4.1v-5.5z"
  }), /*#__PURE__*/React.createElement("g", {
    id: "woman_13_"
  }, /*#__PURE__*/React.createElement("path", {
    className: "st15",
    d: "M343 207.9c-2-1.6-5.1-2.7-7.7-3.2l.4-8.8c-.5.2-1.5.7-2.8 1.3.4-.4.7-.8 1.1-1.2v-30.9c0-.4-.1-.8-.1-1.2 0-1.1-.1-2.3-.2-3.4-.1-.6-.1-1.3-.2-1.9-.2-1.4-.4-2.8-.7-4.2l-.3-1.2c-.3-1.2-.7-2.4-1.1-3.6-.1-.3-.2-.7-.3-1-.5-1.4-1.1-2.9-1.8-4.2-.1-.1-.1-.2-.1-.3-12.6-25.9-47-40.8-75.5-40.8-35.5 0-80.4 23.1-80.4 61.9 0 0-1.2 31.1-1.7 30.8l.4 8.8c-2.6.5-5.7 1.6-7.7 3.2-3.7 2.9-6.1 7.4-6.3 12.4 0 0 6.2 34 15.3 34.4-.1 1.9.1 3.8.4 5.8 0 .4.1.7.2 1.1 0 .3.1.6.1 1 .3 2.3.8 4.5 1.3 6.9 0 .2.1.4.1.6 9.2 35.6 47.3 74 78.3 74 13.4 0 28-7.2 41.2-18.1.4-.3.8-.7 1.2-1 1.4-1.2 2.8-2.4 4.1-3.7l1.8-1.8c1.5-1.5 3-3.1 4.5-4.6.3-.3.6-.6.9-1 1.7-1.9 3.3-3.8 4.9-5.8.5-.7 1-1.3 1.5-2 1.1-1.5 2.2-3 3.2-4.5.5-.7 1-1.4 1.4-2.1 1.4-2.1 2.7-4.3 4-6.4.1-.2.3-.5.4-.8.9-1.6 1.7-3.2 2.5-4.7h-.1c2.9-5.7 5.2-11.6 6.7-17.3 0-.2.1-.4.1-.6.6-2.3 1-4.6 1.3-6.9.1-.3.1-.6.1-1s.1-.7.2-1.1c.2-2 .4-4 .4-5.8 9.1-.4 15.3-34.4 15.3-34.4-.2-5.4-2.6-9.8-6.3-12.7z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M172.8 191.6c-.6-.3-1 4.4-1.4 4.3l-.8 8.9c-2.6.5-4.5 1.6-6.5 3.1-3.7 2.9-6.1 7.4-6.3 12.4 0 0 6.2 34 15.3 34.4-.1 1.9.1 3.8.4 5.8 0 .4.1.7.2 1.1 0 .3.1.6.1 1 .3 2.3.8 4.5 1.3 6.9 0 .2.1.4.1.6 9.2 35.6 47.3 74 78.3 74-63.9-15.4-79.4-92.7-80.7-152.5z",
    fill: "#ffce99"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st16",
    d: "M294.7 326c.4-.3.8-.7 1.2-1 1.4-1.2 2.8-2.4 4.1-3.7l1.8-1.8c1.5-1.5 3-3.1 4.5-4.6.3-.3.6-.6.9-1 1.7-1.9 3.3-3.8 4.9-5.8.5-.7 1-1.3 1.5-2 1.1-1.5 2.2-3 3.2-4.5.5-.7 1-1.4 1.4-2.1 1.4-2.1 2.7-4.3 4-6.4.1-.2.3-.5.4-.8.9-1.6 1.7-3.2 2.5-4.7h-.1c2.9-5.7 5.2-11.6 6.7-17.3 0-.2.1-.4.1-.6.6-2.3 1-4.6 1.3-6.9.1-.3.1-.6.1-1s.1-.7.2-1.1c.2-2 .4-4 .4-5.8 9.1-.4 15.3-34.4 15.3-34.4-.2-5.1-2.6-9.5-6.3-12.4-2-1.6-5.1-2.7-7.7-3.2l.4-8.8c-.3.1-.9.4-1.5.7-1.3 59.8-16.7 132.2-80.6 147.5 13.5-.2 28.2-7.4 41.3-18.3 0-.1 0 0 0 0z"
  }))))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M356.8 97.4h-.2c-5.9 1.1-11 1.2-15.4.9 3.5-4.3 4.7-9 5.1-11.3.1-.6-.6-1.1-1.1-.8-15.5 6.8-33.2-.8-37.2-2.7 3.9-.6 6.9-.9 6.9-.9-26.3-18.1-49.5-15-49.5-15l12-8.2c-27.4-1.7-46.1 8.8-54.9 14.8-1.6.3-3.2.7-4.8 1.1 1.8-3.6 5.3-9.2 5.3-9.2-40.3 10.6-54.7 50.3-58.5 63.4-15.6 19.8-11.7 43.7-5.2 76.4 1.2 6 7.8 22.5 9.8 28.1 0 .1 2.2-32.4 2.2-32.4l19.8-55.4s29.3 7.4 63.8 10c34.7-.3 64.4-5.6 64.4-5.6l16.6 57s-.9 32.2-.9 32.1c4.8-11.2 30.4-39.7 11.5-111.6 5.9-8.5 10.3-30.7 10.3-30.7z",
    clipPath: "url(#SVGID_2_)",
    fill: "#3c2417"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M188.7 115.3s9.2-28.5 42.4-31.5l-8 14.1s40.6-15.4 66.6-8.2c0 0-37 11.5-58.2 43.8 0 0-.5-17 5.9-24.5 0 0-19.2 8.9-22.4 18.2 0 0 .2-13.3 6.7-22.2 0 0-17.6 6.8-20.4 21.2 0 0-3-13.4 2.3-21.1 0 0-11.1 4.3-14.9 10.2zm-25.4 18.3s.3-1.6 1.1-4.3c-15.6 19.8-11.7 43.7-5.2 76.4 1.2 6 7.8 22.5 9.8 28.1 0 0-24-83.8 11.4-103.8 0 0 .4-1.1 1.1-2.9-11 3.9-18.2 6.5-18.2 6.5z",
    clipPath: "url(#SVGID_2_)",
    fill: "#543428"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDefaultProfile);
export default __webpack_public_path__ + "static/media/default-profile.9dc8244ba6d3c1cc1c372cfc8cdd04d3.svg";
export { ForwardRef as ReactComponent };